<template>
  <div @click="$emit('checked', item.pid)" class="card-item">
    <div class="card-info">
      <img v-if="canCheck" :src="checkedId == item.pid ? IconSel : IconDef" class="check-icon">
      <img class="card-icon" src="../../../assets/imgs/credit_card.png">
      <span>{{item.pCardnumber}}</span>
    </div>
    <div v-if="canDelte" @click.prevent="$emit('delete', item.pid)" class="delete">×</div>
  </div>
</template>

<script>
import IconDef from '../../../assets/imgs/icon_def.png'
import IconSel from '../../../assets/imgs/icon_sel.png'
export default {
  name: 'CardItem',
  props: {
    item: {
      type: Object
    },
    canDelte: {
      type: Boolean,
      default: false
    },
    canCheck: {
      type: Boolean,
      default: false
    },
    checkedId: {
      type: [Number, String],
      default: ''
    }
  },
  data () {
    return {
      IconDef,
      IconSel
    }
  }
}
</script>

<style lang="less" scoped>
.card-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 20px;
  height: 80px;
  line-height: 80px;
  border-radius: 8px;
  width: 80%;
  margin: 20px auto 0px;
  text-align: left;
  border: 1px solid #ccc;
  box-shadow: 3px 3px 5px #888888;
}
.card-info {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.check-icon {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}
.card-icon {
  width: 50px;
  height: 30px;
  margin-right: 20px;
}
.delete {
  color: red;
  font-size: 60px;
}
.oncheck {
  justify-content: center;
}
</style>
